<template>
  <Toaster position="top-center" richColors />
  <div class="font-redrose">
    <div class="blur-3xl overflow-hidden h-screen pointer-events-none">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
    <div
      class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg shadow-gray-500/40 p-4 md:p-6 rounded-lg border border-gray-200 z-50 w-11/12 max-w-lg"
    >
      <img
        src="/media/logos/logo_squared.webp"
        class="w-20 h-20 mx-auto mb-3 md:w-32 md:h-32"
      />
      <h2 class="text-xl md:text-4xl font-bold text-center mb-2">
        Circus St. Ottilien 2025
      </h2>
      <p class="text-xs md:text-body text-center">
        Am 27. Juli 2025 endete die diesjährige Spielzeit des Circus St.
        Ottilien. Der Circus war – mit erneut über 12.000 begeisterten
        Besucher:innen – ein großer Erfolg.
        <br /><br />
        In der letzten Vorstellung wurde zudem bekannt, dass unser langjähriger
        Circusdirektor Martin Metz künftig nicht mehr in dieser Rolle tätig sein
        wird. Wir danken ihm von Herzen und wünschen ihm alles Gute für die
        Zukunft.
        <br /><br />
        Diese Website wird in Kürze mit den schönsten Bildern, Videos und
        Artikeln ergänzt. Außerdem freuen wir uns über Ihr Feedback zum
        Vorverkaufsprozess – klicken Sie dafür auf die folgende Schaltfläche:
      </p>
      <div class="flex justify-center mt-4 md:mt-6">
        <NuxtLink
          to="https://forms.office.com/e/0bQHxC0wCG"
          class="button block text-center w-full max-w-xs"
          target="_blank"
          data-umami-event="feedback-vorverkauf"
        >
          Feedback zum Vorverkauf
        </NuxtLink>
      </div>
      <p class="text-center mt-4 md:mt-6 text-xs md:text-body">
        Wir freuen uns, Sie in Ottilien wieder begrüßen zu dürfen, wenn es heißt
        …
      </p>
      <h2 class="text-base md:text-2xl font-bold text-center mt-2">
        Hereinspaziert zum Circus St. Ottilien 2028!
      </h2>
    </div>
  </div>

  <ClientOnly>
    <div
      v-if="!hasClickedWebteamBanner && !hidden"
      class="fixed md:bottom-10 md:right-10 bottom-0 bg-white shadow-xl shadow-gray-500/40 p-4 rounded-lg border border-gray-200 flex flex-col justify-end items-end z-50"
    >
      <p class="text-body font-redrose max-w-md">
        Diese Website wurde vom Webteam der Schule erstellt. Das Webteam sucht
        immer nach neuen Mitgliedern, die Lust haben, sich in Webdesign und
        Softwareentwicklung auszuprobieren. Wenn du Interesse hast, melde dich
        gerne bei uns!
      </p>

      <div class="flex flex-row gap-3 mt-4 justify-between w-full items-center">
        <NuxtLink
          to="mailto:developers@ottilianer.de"
          class="block text-primary"
          @click="clickWebteamBanner"
        >
          Kontakt aufnehmen
        </NuxtLink>
        <button class="button block" @click="clickWebteamBanner">Okay</button>
      </div>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
const hidden = ref(false);

const hasClickedWebteamBanner = computed(() => {
  return localStorage.getItem("webteam-banner") === "true";
});

const clickWebteamBanner = () => {
  localStorage.setItem("webteam-banner", "true");
  hidden.value = true;
};
</script>
